import React, { useRef } from 'react';

const MainStone = ({ texture }) => {
  const mesh = useRef();

  return (
    <mesh
      position={[-1.2, -2, 0]}
      ref={mesh}
      scale={[1, 1, 1]}
    >
      <boxGeometry args={[8, 2, 4]} />
      <meshStandardMaterial map={texture} />
    </mesh>
  );
};

export default MainStone;
